

export class VehicleModelSelectByCompanyIdAndFuelTypeOutputData implements IVehicleModelSelectByCompanyIdAndFuelTypeOutputData {
    /** The auto-generated id of the vehicle model master */
    vehicle_model_id!: number;
    /** The vehicle model name with 255 character limit */
    vehicle_model_name!: string;

    constructor(data?: IVehicleModelSelectByCompanyIdAndFuelTypeOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_model_id = _data["vehicle_model_id"];
            this.vehicle_model_name = _data["vehicle_model_name"];
        }
    }

    static fromJS(data: any): VehicleModelSelectByCompanyIdAndFuelTypeOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleModelSelectByCompanyIdAndFuelTypeOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_model_id"] = this.vehicle_model_id;
        data["vehicle_model_name"] = this.vehicle_model_name;
        return data; 
    }
}

export interface IVehicleModelSelectByCompanyIdAndFuelTypeOutputData {
    /** The auto-generated id of the vehicle model master */
    vehicle_model_id: number;
    /** The vehicle model name with 255 character limit */
    vehicle_model_name: string;
}

